import React, { useRef } from "react"

interface MedalTiltProps {
  src: string;
  maxRotate?: number;
  size?: number;
  onMouseMove?: (e: React.MouseEvent<HTMLDivElement>) => void;
  onMouseLeave?: (e: React.MouseEvent<HTMLDivElement>) => void;
}

const MedalTilt: React.FC<MedalTiltProps> = ({
  src,
  maxRotate = 10,
  size = 200,
  onMouseMove,
  onMouseLeave
}) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const medalRef = useRef<HTMLImageElement | null>(null);
  const shineRef = useRef<HTMLDivElement | null>(null);

  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    const medal = medalRef.current;
    const shine = shineRef.current;
    const container = containerRef.current;
    if (!medal || !shine || !container) return;

    const rect = container.getBoundingClientRect();

    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const halfW = rect.width / 2;
    const halfH = rect.height / 2;

    // Поворот медали
    const rotateY = -Math.abs(((x - halfW) / halfW) * maxRotate);
    const rotateX = -Math.abs(-((y - halfH) / halfH) * maxRotate);
    medal.style.transform = `rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;

    // Перемещение блика
    const shineX = (x / rect.width) * 100;
    const shineY = (y / rect.height) * 100;
    shine.style.background = `none`;

    // Лёгкое затухание блика при уходе от центра
    const distance = Math.sqrt(Math.pow(x - halfW, 2) + Math.pow(y - halfH, 2));
    const maxDist = Math.sqrt(halfW * halfW + halfH * halfH);
    shine.style.opacity = String(1 - distance / maxDist);

    onMouseMove?.(e);
  };

  const handleMouseLeave = (e: React.MouseEvent<HTMLDivElement>) => {
    if (medalRef.current) {
      medalRef.current.style.transform = "rotateX(0deg) rotateY(0deg)";
    }
    if (shineRef.current) {
      shineRef.current.style.opacity = "0";
    }

    onMouseLeave?.(e);
  };

  return (
    <div
      ref={containerRef}
      style={{
        width: size,
        height: size,
        position: "relative",
        perspective: "600px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "grab",
      }}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
    >
      {/* Блик */}
      <div
        ref={shineRef}
        style={{
          position: "absolute",
          inset: 0,
          pointerEvents: "none",
          opacity: 0,
          transition: "opacity 0.2s ease-out",
          mixBlendMode: "soft-light",
					zIndex: 2
        }}
      />

      {/* Медаль */}
      <img
        ref={medalRef}
        src={src}
        alt="medal"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "contain",
          transformStyle: "preserve-3d",
          transition: "transform 0.1s ease-out",
					zIndex: 1
        }}
      />
    </div>
  );
};

export default MedalTilt;
